import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

const API_URL = environment.apiUrl + 'auth/hubspot/';

@Injectable({
  providedIn: 'root'
})
export class HubspotService {

  constructor(
    private http: HttpClient
  ) { }

  refreshAccessToken(customerId: string) {
    return this.http.get(API_URL + 'refresh-token?customerId=' + customerId, { responseType: 'json' });
  }
}
